import { Injectable } from '@angular/core';
import { of, Subject } from 'rxjs';
import { delay } from 'rxjs/operators';

export interface LoaderConfigOptions {
  backdrop?: boolean;
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class LoaderUtilService {
  isLoading: Subject<boolean> = new Subject<boolean>();
  message: Subject<string> = new Subject<string>();
  configOptions: LoaderConfigOptions;

  constructor() {}

  show(message?: string, options?: LoaderConfigOptions) {
    this.configOptions = options;
    this.setMessage(message);
    this.isLoading.next(true);
    if (options?.duration) {
      this.hideAfterDuration(options?.duration);
    } else {
      this.hideAfterDuration(4000);
    }
  }

  setMessage(message: string) {
    this.message.next(message);
  }

  hide() {
    // this.isLoading.next(false);
    this.hideAfterDuration(300);
  }

  private hideAfterDuration(duration: number) {
    of(duration)
      .pipe(delay(duration))
      .subscribe({
        next: (result: number) => {
          this.isLoading.next(false);
        },
      });
  }
}
